import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'are_there_restrictions_workers_applying_taking_leave'

export const dataPointDefinition = {
  retracedId: 'are_there_restrictions_workers_applying_taking_leave',
  name: 'Are there any restrictions to workers applying for or taking leave?',
  description:
    'The intent of this question is to understand if there are any restrictions to workers applying for or taking leave. "Restrictions" refer to scenarios in which workers cannot take legally mandated leave.',
  meta: {
    slcpMeta: {
      key: 'wb-23--8',
      number: 'WH-WOR-26',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-23--8', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35430,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
